import { Stack, styled } from '@mui/material'
import { useAtom } from 'jotai'
import { memo } from 'react'
import { faucetTabs, faucetTypeAtom } from './atoms'

const Wrap = styled(Stack)`
  flex-direction: row;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`
const Tab = styled('div')`
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 6px;
  color: ${(props) => props.theme.color?.text60};
  cursor: pointer;
  &.active {
    font-weight: 600;
    color: ${(props) => props.theme.color?.primary40};
    background-color: ${(props) => props.theme.color?.primary10};
  }
`

export const FaucetTabs = memo(() => {
  const [faucetType, setFaucetType] = useAtom(faucetTypeAtom)

  return (
    <Wrap>
      {faucetTabs.map(({ key, name }) => (
        <Tab
          key={key}
          onClick={() => setFaucetType(key)}
          className={faucetType === key ? 'active' : ''}>
          {name}
        </Tab>
      ))}
    </Wrap>
  )
})
